function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M29.1387 29.1104H30.1504V30.8877H29.1387V33H26.835V30.8877H22.9863L22.8496 29.4795L26.835 23.0674V23.0469H29.1387V29.1104ZM25.0439 29.1104H26.835V26.0479L26.6914 26.2803L25.0439 29.1104Z",
  fill: "black"
});

function SvgCart4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart4);
export default __webpack_public_path__ + "static/media/cart4.2c4169b5.svg";
export { ForwardRef as ReactComponent };